import React from 'react';
import { Col } from 'reactstrap';
import { AdditionalLabelledMultiSelect } from '..';
import { LabelledMultiSelect } from '../../../../LabelledMultiSelect';

export function LocationsLabelledMultiSelectCol(props: {
  additionalLabelledMultiSelect: AdditionalLabelledMultiSelect;
}) {
  return (
    <Col xs='12' md='4' xl='2' className='mt-2'>
      <LabelledMultiSelect
        options={props.additionalLabelledMultiSelect.all}
        selected={props.additionalLabelledMultiSelect.selected}
        label='Locations'
        placeholder='All Locations'
        singleSelectedText='1 selected location'
        manySelectedText='%d selected locations'
        onChange={props.additionalLabelledMultiSelect.handleFilterUpdate(
          'locations',
        )}
      />
    </Col>
  );
}
